import React, {PureComponent, CSSProperties} from 'react'
import PropTypes from 'prop-types'
import Theme, {mediaQueries} from 'Theme'
import cxs from 'cxs/component'

class Scroll extends PureComponent {
  render() {
    return <StyledScroll {...this.props} />
  }
}

export default Scroll

const StyledScroll = cxs('div')({
  flex: 1,
  overflowY: 'scroll',
  [mediaQueries.desktop]: {
    overflowY: 'auto'
  } as CSSProperties
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/Scroll.tsx